import { IResponse, IResponsePagination } from '@/types/common';
import {
  ICreatePartnerRequest,
  IGetListPartnerRequest,
  IUpdatePartnerRequest,
} from '@/types/request';
import { IGetListPartnerResponse } from '@/types/response';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class Partner {
  getList = (
    params: IGetListPartnerRequest,
  ): Promise<IResponsePagination<IGetListPartnerResponse>> => {
    return axiosClient.get(ENDPOINT.PARTNER.GET_LIST, { params: params });
  };

  delete = (id: number) => {
    return axiosClient.delete(
      ENDPOINT.PARTNER.DELETE.replace(':id', String(id)),
    );
  };

  create = (body: ICreatePartnerRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.PARTNER.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<any>> => {
    return axiosClient.get(
      ENDPOINT.PARTNER.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (
    data: IUpdatePartnerRequest,
    id: number,
  ): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.PARTNER.UPDATE.replace(':id', String(id)),
      data,
    );
  };
}

export const PartnerService = new Partner();
